export enum PlaceAddresCompoponent {
  ZIP_CODE = 'postal_code',
  COUNTRY = 'country',
  STATE = 'administrative_area_level_1',
  CITY = 'administrative_area_level_2',
  TOWN = 'sublocality_level_1',
  AREA = 'sublocality_level_2',
  NEAREST_ROAD = 'route',
  STREET_NUMBER = 'street_number',
}

class PlacesAutocomplete {
  getAddressComponent = (
    address_components: google.maps.GeocoderAddressComponent[],
    _key: (keyof typeof PlaceAddresCompoponent)[]
  ) => {
    const arrKey = Array.isArray(_key) ? _key : [_key];
    const value: { [key in typeof arrKey[number]]?: string | null } = {};

    arrKey.forEach(key => {
      const result = address_components.filter(aComp =>
        aComp.types.some(typesItem => typesItem === PlaceAddresCompoponent[key])
      );
      if (result != null && result.length > 0) {
        value[key] = result[0].long_name;
      } else {
        value[key] = null;
      }
    });

    return value! ?? {};
  };
}

export const placesAutocomplete = new PlacesAutocomplete();
